export default __webpack_public_path__ + "static/media/bas.dc72e507.png";